function convertDateBetweenTimeZones(date, i18n, {
  from,
  to,
}) {
  const dateString = i18n.formatDate(date, {
    timeZone: from,
  });

  return i18n.parseDate(dateString, {
    timeZone: to,
  });
}

export function convertMachineDateToUTCDate(date, i18n) {
  return convertDateBetweenTimeZones(date, i18n, { from: null, to: 'UTC' });
}

export function convertUTCDateToMachineDate(date, i18n) {
  return convertDateBetweenTimeZones(date, i18n, { from: 'UTC', to: null });
}

export function formatDate(date, i18n) {
  return i18n.dateFormatter({ timeZone: 'UTC' })(new Date(date));
}

export function displayDate(date, noDateMessage, i18n) {
  if (date) {
    return formatDate(date, i18n);
  }

  return i18n.getString(noDateMessage);
}

export function getCurrentDate() {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}
